import styled from 'styled-components';
import { AppTable as AppTableComponent } from 'components/AppTable';
import { Button as ButtonComponent } from 'components/Button';
import { FormItem } from 'components/UI/Form';

export const CartFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AppTable = styled(AppTableComponent)<{ $loading: boolean }>`
  width: 100%;
  border: none;
  margin-bottom: unset;
  opacity: ${({ $loading }) => ($loading ? 0.5 : 1)};
`;

export const AuthHint = styled.div`
  padding: 16px;
  color: var(--v3-text-color);
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;

export const Button = styled(ButtonComponent)`
  &&&& {
    justify-content: center;
    margin: 0 24px 22px;
  }
`;

export const PaymentButtonTextWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const ButtonText = styled.div`
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
`;

export const TextDot = styled.div`
  font-size: 7px;
`;

export const FormItemWide = styled(FormItem)`
  grid-column: 1 / 3;
`;

export const Label = styled.h3`
  margin: 0;
  color: var(--v3-text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;
  &::after {
    content: '*';
    position: relative;
    top: -3px;
    color: var(--v3-error-color);
    font-size: 14px;
    font-family: SimSun, sans-serif;
  }
`;

export const PaymentWrapper = styled.div`
  padding: 30px;
  .ant-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const CardDetailWrapper = styled.div`
  display: flex;
  background-color: var(--v3-blue-3);
  padding: 13px 22px;
  border-radius: 14px;
  justify-content: space-between;
`;

export const CardWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const CardText = styled.div`
  color: var(--v3-processing-color);
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.3px;
  display: flex;
  align-items: center;
`;

export const CardSubText = styled.div`
  color: var(--v3-blue-5);
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.7px;
  display: flex;
  align-items: center;
`;
